module.exports = __webpack_public_path__ + "static/media/highFive.205c1b20.svg";